export const toFullNameParam = (nameText: string): string | undefined =>
  nameText.trim() || undefined;
